import { Lock } from "lucide-react";
import { lockedTiles } from "./summaryModel";
import { S } from "./summaryCopy";

// What the paid report contains, as honest lock cards. Text comes from the
// copy file and carries counts only: never directory/platform names, legal
// titles or measured values.
export default function LockedTiles({ data, lang }) {
  const tiles = lockedTiles(data);
  if (!tiles.length) return null;
  const C = (S[lang] || S.de).tiles;
  return (
    <section data-testid="locked-tiles" className="mt-6">
      <h2 className="mb-1.5 font-heading text-lg font-semibold sm:text-xl">{C.title}</h2>
      <p className="mb-4 text-base text-muted-foreground">{C.desc}</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {tiles.map((t, i) => {
          const { title, body } = C[t.id](...t.args);
          return (
            <div key={t.id} className={`flex flex-col rounded-2xl border bg-card p-4 shadow-sm${tiles.length % 2 === 1 && i === tiles.length - 1 ? " sm:col-span-2" : ""}`}>
              <h3 className="flex items-center gap-2 text-base font-semibold">
                <Lock className="h-4 w-4 shrink-0 text-muted-foreground" /> <span className="min-w-0">{title}</span>
              </h3>
              <span className="mt-1 self-start rounded-full bg-secondary px-2 py-0.5 text-xs text-muted-foreground">{C.lockedHint}</span>
              <p className="mt-2 text-base text-muted-foreground">{body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
